import * as Common from '@/tenant/common';

export class ChargeJournalReportQuery extends Common.ReportQuery {
    constructor(){
        super("ChargeJournalReportQuery", null);
    }
    public salesPurchaseFlag: number;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public bookDateFrom: Date = null;
    public bookDateTo: Date = null;
    public onExcelExport:boolean = false;           
}

export class ChargeJournalReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='ChargeJournalReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
